function AnalyticsContainer() {
  return <div>AnalyticsContainer</div>;
}

export default AnalyticsContainer;
